import React, { useEffect } from "react";
import { TipInterface } from "../../../../store/mine_craft/tipsSlice";

import { Button, Form, Input } from "antd";
import { AVAILABLE_LOCALES } from "../../../../configs/constants";

interface propsInterface {
  params: TipInterface;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form]  = Form.useForm();
  const locales: string[] = [...Object.keys(params.title_translations), ...params.empty_locales];

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderTitle = (locale: string) => (
    <Form.Item key={locale} name={['title_translations', locale]} label={`${AVAILABLE_LOCALES[locale]} :${locale}`}>
      <Input placeholder={`Title_${locale}`} />
    </Form.Item>
  )

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='entity_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      { locales.map(renderTitle) }

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
